export const name = 'scrollToAnchor' as const
export const SamePageScrollSymbol = Symbol('SamePageScroll')
